<template>
    <!-- 次卡 -->	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
				<el-form-item>
					<el-input v-model="filters.name" @keyup.enter.native="getRechargeableConsumption"    placeholder="项目名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="width:100%; height:100%;" type="primary" v-on:click="getRechargeableConsumption" icon="el-icon-search">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">添加消费项目</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="RechargeableCard" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<!-- <el-table-column type="id" width="60">
			</el-table-column> -->
			<el-table-column prop="Name" label="项目名称" width="150" sortable>
			</el-table-column>
			<el-table-column prop="Amount" label="项目金额" width="120" sortable>
			</el-table-column>
			<el-table-column prop="State" label="项目状态" width="120" sortable>
			</el-table-column>			
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>			
			<el-table-column label="操作" width="150">
				<template  slot-scope="scope">
					<!-- <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
					<el-button type="danger" size="small" @click="handleDel(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--编辑界面-->
		<!-- <el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
				
				<el-form-item label="套餐名称" prop="Name">
					<el-input v-model="addForm.Name" auto-complete="off"></el-input>
				</el-form-item>
					<el-form-item label="套餐次数" prop="Frequency">
					<el-input v-model="addForm.Name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input type="textarea" v-model="addForm.Remark"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog> -->

		<!--新增界面-->
		<el-dialog title="新增项目" v-model="addFormVisible" :close-on-click-modal="false">
			<el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
				<el-form-item label="项目名称" prop="Name">
					<el-input v-model="addForm.Name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="消费金额" prop="Amount">
					<el-input v-model.number="addForm.Amount" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input type="textarea" v-model="addForm.Remark"></el-input>
				</el-form-item>							
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>
<script>
	import util from '../../common/js/util'

import {getConsumptionComboList,addConsumptionCombo,editConsumptionCombo,removeConsumptionCombo} from '../../api/api';
export default {
	data(){
		return {
			total:0,
			page:1,
			listLoading:false,
			filters:{
              name:''
			},
			sels: [],//列表选中列
			RechargeableCard:[],

			 editFormVisible:false,
			 editLoading:false,
			 editFormRules:{},
			 editForm:{},
			 
			addFormVisible:false,
			addLoading: false,
			addFormRules:{
				Name:[				
						{ required: true, message: '请输入项目名称', trigger: 'blur' }				
				],
				Amount: [
						{ required: true, message: '请输入项目金额'},
						{ type: 'number', message: '必须为数字值'}							
				]
			},
			addForm:{
				  Name:'',
				  Amount:'',
				  GiftAmount:'',
				  Remark:''
			}
		}
	},
	methods:{
		//新增	
				//删除
			handleDel(row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { Id:row.Id};
					// console.log(para);
					removeConsumptionCombo(para).then((res) => {
                    //   console.log(res);
						this.listLoading = false;
						//NProgress.done();
						 if(res.data.Success==true)
						 {
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getRechargeableConsumption();

						 }else
						 {
							this.$message({
							message: res.data.Msg,
							type: 'error'
						}); 
						 }
					});
				}).catch((error) => {
				});
			},
			
		handleCurrentChange(val) {
				this.page = val;
				this.getRechargeableConsumption();
			},
		selsChange: function (sels) {
				this.sels = sels;
			},
		//显示新增界面
			handleAdd: function () {
				this.addFormVisible = true;
				this.addForm = {
				  Name:'',
				  Amount:'',
				  Remark:''
					
				};},
		getRechargeableConsumption(){
			let para = {
					PageIndex: this.page-1,					
					PageSize:10,
					Name:this.filters.Name
				};
				this.listLoading = true;
				getConsumptionComboList(para).then((res)=>{
					this.total = res.data.TotleCount;
					// console.log(res);
					this.RechargeableCard =res.data.Data;
					this.listLoading = false;
				})
				.catch(error=>{
                 alert('网络错误');
                });
		},
		addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.addLoading = true;
							//NProgress.start();
							let para= Object.assign({}, this.addForm);	
							
							if(this.addForm.Amount<0)
							{
								this.$message({
									message: '金额不能是负数',
									type: 'error'
								});
							}
							// console.log(para);
					        // para.StartDate = (!para.StartDate || para.StartDate == '') ? '' : util.formatDate.format(new Date(para.StartDate), 'yyyy-MM-dd');
					        // para.EndDate = (!para.EndDate || para.EndDate == '') ? '' : util.formatDate.format(new Date(para.EndDate), 'yyyy-MM-dd');
							addConsumptionCombo(para).then((res) => {							
								this.addLoading = false;
								//NProgress.done();
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}
								this.$refs['addForm'].resetFields();
								this.addFormVisible = false;
								this.getRechargeableConsumption();
							}) .catch(error=>{
                            alert('系统错误');
                            });														
						});
					}
				});
			},		
	}
	,
		mounted() {
			this.getRechargeableConsumption();
		}
}
</script>



// WEBPACK FOOTER //
// RechargeableCardConsumption.vue?44c1d25b